<div
    #dropdownMenu
    ref="target"
    class="relative h-full custom-dropdown"
    [ngClass]="{
        'default-dropdown': dropdownStyle === PrefixDropdownStyle.Default,
        'program-available-dropdown': dropdownStyle === PrefixDropdownStyle.ProgramAvailableLanguage,
    }">
    <button type="button" [class]="btnClass + ' !font-normal h-full w-full'" (click)="toggleOpen($event)">
        <span *ngIf="title" class="dropdown-title"> {{ title | translate }}: </span>
        <span class="dropdown-text">
            {{ selectedDropdownName | translate }}
        </span>
        <mat-icon class="duration-300 transition-all" [ngClass]="isOpen ? 'rotate-180' : ''"
            >keyboard_arrow_down</mat-icon
        >
    </button>
    <div [ngClass]="isOpen ? 'show' : 'hide'" [class]="dropdownClass + ' bg-white custom-scroll'">
        <button
            *ngFor="let item of currentOptions"
            type="button"
            class="px-4 py-2 cursor-pointer text-base text-black rounded-md duration-300 w-full text-start block"
            [ngClass]="selected === item ? 'bg-primary/5' : ''"
            (click)="selectOption(item)">
            {{ item.name | translate }}
        </button>
    </div>
</div>
